import { Badge } from '@@/ui/primitives';
import * as YAML from 'yaml';

interface YamlViewerProps {
  value: unknown;
  full?: boolean;
}

function calculateStringSize(value: unknown): string {
  const sizeInBytes = new TextEncoder().encode(JSON.stringify(value)).length;

  if (sizeInBytes > 1000) {
    return Math.round(sizeInBytes / 1024) + ' KB';
  }

  return sizeInBytes + ' bytes';
}

export function YamlViewer({ value, full = false }: YamlViewerProps) {
  const size = calculateStringSize(value);

  if (full) {
    const yamlString =
      typeof value === 'object' && value !== null ? YAML.stringify(value, null, 2) : String(value || '');

    return (
      <div className='flex flex-col gap-2'>
        <Badge variant='outline' className='text-xs text-neutral-950 border-neutral-300 tabular-nums w-fit'>
          {size}
        </Badge>
        <div className='bg-neutral-50 p-3 rounded-md border border-neutral-200 max-h-96 overflow-auto'>
          <pre className='text-sm! font-mono whitespace-pre-wrap wrap-break-word'>{yamlString || '(empty)'}</pre>
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-row items-center gap-2'>
      <Badge variant='outline' className='text-xs text-neutral-950 border-neutral-300 tabular-nums'>
        {size}
      </Badge>
    </div>
  );
}
